// extracted by mini-css-extract-plugin
export var center = "_15-2";
export var clickableRow = "_15-5";
export var expandedRow = "_15-7";
export var hoverable = "_15-4";
export var left = "_15-1";
export var right = "_15-3";
export var row = "_15-0";
export var selectedRow = "_15-6";
export var summaryRow = "_15-8";